import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-csr-page',
  templateUrl: './csr-page.component.html',
  styleUrls: ['./csr-page.component.scss']
})
export class CsrPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
